const GenreTag = ({ text, accentColor }) => {
    const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };
  
    return (
      <li
        className="flex w-fit px-3 py-1 rounded-full text-amber-50 text-base pangram-sans-bold"
        style={{ backgroundColor: accentColor }}
      >
        {capitalizeFirstLetter(text)}
      </li>
    );
  };

export default GenreTag;